import {isFeatureEnabled} from '@github-ui/feature-flags'

// Controls rendering the mini merge status section on the top of Overview
export function isMiniMergeStatusEnabled() {
  return isFeatureEnabled('prs_overview_mini_merge_status')
}
